export function createLinkHtmlElement(url: string): HTMLLinkElement {
  const link = document.createElement('link');

  link.setAttribute('rel', 'stylesheet');
  link.setAttribute('href', url);

  return link;
}
